<template>
  <v-snackbar right v-model="snackBar.status" :color="snackBar.color" :timeout="snackBar.timeout">
    <v-icon color="white">{{snackBar.icon}}</v-icon>
    {{ snackBar.text }}
    <v-btn color="white" text @click="snackBar.status = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'snackBar',
  data: () => ({
    snackBar: {}
  }),
  created () {
    this.snackBar = this.$store.state.snackBar
  }
}
</script>

<style scoped>

</style>
